/**
 * Main page implementation.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var id            = 'pageChannels',
    app           = require('mag-app'),
    appConfig     = require('../config'),
    Page          = require('stb-component-page'),
    Scroll        = require('stb-component-scrollbar'),
    page          = new Page({$node: document.getElementById(id)}),
    PanelSet      = require('mag-component-panel-set'),
    PanelExtended = require('mag-component-panel'),
    LayoutList    = require('mag-component-layout-list'),
    dom           = require('spa-dom'),
    keys          = require('stb-keys'),
    Button        = require('stb-component-button'),
    Flicker       = require('spa-component-flicker'),
    Footer        = require('mag-component-footer');


page.clock = new Flicker({
    className: 'clock',
    interval: 1000,
    render: function ( $item ) {
        var time  = new Date(),
            hours = time.getHours(),
            mins  = time.getMinutes();

        $item.innerText = (hours > 9 ? hours : '0' + hours) + ':' + (mins > 9 ? mins : '0' + mins);
    }
});
page.add(page.clock);
page.clock.start();

page.footer = new Footer({
    visible: true,
    parent: page,
    data: [
        {
            code: keys.f4,
            title: gettext('Search'),
            action: function () {
                if ( page.panelSelect.list.$focusItem ) {
                    page.panelSelect.list.$focusItem.classList.remove('focus');
                }
                page.panelSelect.searchHolder.focus();
            }
        }
    ]
});

// panel: add new record
page.panelSelect = new PanelExtended({
    title: gettext('Select channel'),
    main: true,
    visible: true,
    className: 'panelSelect'
});

page.panelSelect.searchHolder = new Button({
    className: 'panelInput',
    events: {
        keydown: function ( event ) {
            switch ( event.code ) {
                case keys.ok:
                    window.core.intent({
                        action: 'keyboard',
                        data: {
                            type: 'text',
                            mode: 'qwerty',
                            title: gettext('ENTER CHANNEL'),
                            description: gettext('RECORDS'),
                            value: page.panelSelect.input.innerText
                        },
                        events: {
                            done: function ( doneEvent ) {
                                page.panelSelect.input.innerText = doneEvent.value;
                                appConfig.chansSearch = doneEvent.value;
                                if ( page.panelSelect.list.$focusItem ) { page.panelSelect.list.$focusItem.index = 0; }
                                page.panelSet.reset();
                            }
                        }
                    }, function ( error ) {
                        console.log(error);
                    });
                    break;
                case keys.up:
                case keys.down:
                    if ( page.panelSelect.list.data.length ) {
                        page.panelSelect.list.focus();
                        if ( page.panelSelect.list.$focusItem ) {
                            page.panelSelect.list.$focusItem.classList.add('focus');
                        }
                    }
                    break;
            }
        }
    }
});

page.panelSelect.searchHolder.$body.appendChild(dom.tag('div', {className: 'theme-icon theme-icon-search'}));
page.panelSelect.searchHolder.$body.appendChild(page.panelSelect.input = dom.tag('div', {className: 'searchInput'}));

page.panelSelect.scroll = new Scroll({});

page.panelSelect.list = new LayoutList({
    scroll: page.panelSelect.scroll,
    noData: gettext('No channels'),
    focusIndex: 0,
    size: 6,
    data: [],
    events: {
        overflow: function () {
            if ( page.panelSelect.list.$focusItem ) {
                page.panelSelect.list.$focusItem.classList.remove('focus');
            }
            page.panelSelect.searchHolder.focus();
        },
        'click:item': function ( event ) {
            function startRecord ( data ) {
                app.intent = {
                    action: 'record',
                    data: {
                        uri: data.url,
                        name: data.name,
                        id: data.id,
                        censored: data.censored || (data.genre && data.genre.censored),
                        pvr: {
                            local: data.local_pvr,
                            server: data.pvr
                        },
                        merge: true
                    }
                };
            }

            if ( (window.core.accessControl && !window.core.accessControl.state) &&
                (event.$item.data.value.censored || (event.$item.data.value.genre && event.$item.data.value.genre.censored)) ) {
                window.core.accessControl.request(function ( error ) {
                    if ( !error ) {
                        startRecord(event.$item.data.value);
                        app.route(app.pages.add);
                    }
                });
            } else {
                startRecord(event.$item.data.value);
                app.route(app.pages.add);
            }
        },
        keydown: function ( event ) {
            LayoutList.prototype.defaultEvents.keydown.call(this, event);
        },
        'data:error': function ( event ) {
            debug.log('List error get data', 'red');
            debug.log(event);
        }
    }
});

page.panelSelect.add(page.panelSelect.searchHolder, page.panelSelect.list, page.panelSelect.scroll);

page.panelSet = new PanelSet({
    visible: true,
    $node: document.getElementById('panelSetChans'),
    focusIndex: 0,
    panels: [page.panelSelect]
});
page.panelSet.reset = function () {
    if ( window.core.plugins.tvBackend ) {
        window.core.plugins.tvBackend.getChannels({
            search: appConfig.chansSearch,
            pvr: true
        }, function ( error, data ) {
            var index,
                result = [];

            if ( error ) {
                debug.log('core.plugins.tvBackend.getChannels function returned error');
            }
            if ( !data || data.length < 1 ) {
                page.panelSelect.list.init({data: []});
                page.footer.hide();
                page.panelSelect.scroll.hide();

                return;
            }
            for ( index = 0; index < data.length; index++ ) {
                result[index] = {
                    items: [
                        {className: 'number', value: data[index].number.toString()},
                        {className: 'title', value: data[index].name},
                        {className: 'placeholder ' + (data[index].censored ? ' theme-icon theme-icon-lock' : '')}
                    ],
                    value: data[index]
                };
            }
            page.panelSelect.list.init({
                data: result,
                focusIndex: page.panelSelect.list.$focusItem ? page.panelSelect.list.$focusItem.index : 0
            });
            page.panelSelect.scroll.init({realSize: data.length, viewSize: 6});
            page.panelSelect.show();
            page.footer.show();
            page.panelSelect.list.$focusItem.classList.add('focus');
            page.panelSelect.list.focus();
        });
    } else {
        page.panelSelect.list.init({data: [], focusIndex: 0});
        page.panelSelect.scroll.init({realSize: 0, viewSize: 6});
        page.panelSelect.show();
        page.footer.show();
        page.panelSelect.searchHolder.focus();
    }
};
page.add(page.panelSet);


page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            app.route(app.pages.add);
            break;
    }
});

page.reset = function () {
    page.panelSelect.input.innerText = (appConfig.chansSearch || '');
    page.panelSet.reset();
};

page.addListener('show', function () {
    page.panelSet.focus();
    page.reset();
});


// public
module.exports = page;
